{
  "infoCard": {
    "labels": {
      "aircraft": "Flugzeug",
      "utilization": "Auslastung",
      "trips": "Flüge",
      "doorSize": "Torgröße",
      "estTowTime": "Schleppzeit",
      "estValue": "Gesch. Wert",
      "total": "Total",
      "transients": "Transients",
      "dimensions": "Abmessungen",
      "parameters": "Parameter"
    },
    "tooltips": {
      "aircraftCount": "# Flugzeuge im Hangar / # gewünschte Flugzeuge",
      "utilization": "Gestapelte Flugzeugausl. / Alle Flugzeuge auf dem Bildschirm Ausl. Du kannst die Berechnung der Auslastung unter Einstellungen > Konfiguration anpassen.",
      "towTime": "Geschätzte Zeit, um alle Flugzeuge aus dem Hangar zu schleppen.",
      "tripsCount": "Aktive Flüge / Zukünftige Flüge diesem Hangar zugewiesen",
      "estimatedValue": "Geschätzter Wert deines Hangars. Das umfasst alle Dauermieter und alle Transients, die du im Hangar unterbringen kannst.",
      "transientValue": "Revenue from overnight transient aircraft."
    },
    "units": {
      "perDay": " / Tag",
      "perMonth": "/Monat"
    }
  },
  "customStackDialog": {
    "title": "Passe deinen Stack an",
    "buttons": {
      "back": "Zurück",
      "runStack": "Stack starten"
    },
    "sections": {
      "spacingSOP": "Abstand-SOP",
      "preferences": "Einstellungen"
    },
    "labels": {
      "horizontal": "Horizontal (ft)",
      "vertical": "Vertikal (ft)",
      "leftWall": "Linke Wand (ft)",
      "backWall": "Rückwand (ft)",
      "rightWall": "Rechte Wand (ft)",
      "towingEquipment": "Schleppausrüstung für Stack",
      "ignore": "Ignorieren?",
      "allowOverlap": "Überlappung ok",
      "ignoreNoseInOut": "Nasen-Präferenzen ignorieren",
      "ignoreFrontBack": "Vorder-/Rückseiteneinstellungen ignorieren",
      "ignoreOutsideHangar": "Hangar-Außenbereichs-Einstellungen ignorieren",
      "cloudPrioritization": "Cloud-Positionspriorisierung verwenden",
      "sampleSize": "Stichprobengröße",
      "cornerStrategy": "Eckstrategie",
      "xyWeights": "XY-Gewichte",
      "xWeight": "X",
      "yWeight": "J",
      "densityThreshold": "3D-Dichteschwellenwert"
    },
    "tooltips": {
      "spacingSOP": "SOPs überschreiben. Standardmäßig werden die für dein FBO festgelegten SOPs verwendet.",
      "preferences": "Passe deine Stapeleinstellungen an. Diese gelten für alle Flugzeuge."
    },
    "descriptions": {
      "allowOverlap": "Erlaube dem Algorithmus, Flugzeuge zu überlappen.",
      "ignoreNoseInOut": "Erlaube dem Algorithmus, deine Schleppausrichtungs-Einstellungen zu verwenden.",
      "ignoreFrontBack": "Erlaube dem Algorithmus, deine Präferenz für vordere oder hintere Reihe zu verwenden.",
      "ignoreOutsideHangar": "Erlaube dem Algorithmus, deine kann weggelassen werden-Präferenzen zu berücksichtigen.",
      "cloudPrioritization": "Verwendet Cloud (ConvexHull)-Positionspriorisierung, um zu bestimmen, welche Positionen ausgewertet werden."
    }
  },
  "evaluatingStackDialog": {
    "titles": {
      "selectStack": "Stapel auswählen",
      "evaluating": "Stapel wird ausgewertet"
    },
    "progress": {
      "preparing": "Startvorbereitung läuft...",
      "scenariosEvaluated": "{{formattedCount}} Szenarien ausgewertet"
    },
    "complete": {
      "modifyLink": "Versuche, deine Anforderungen anzupassen.",
      "finishedMessage": "Nachricht abgeschlossen"
    },
    "buttons": {
      "cancel": "Stapel abbrechen",
      "endEarly": "Stapeln vorzeitig beenden"
    }
  },
  "runStack": {
    "buttons": {
      "autoStack": "AutoStack",
      "autoStackDev": "AutoStack Dev",
      "results": "Ergebnisse",
      "cancel": "Abbrechen",
      "customizeStack": "Stapel anpassen",
      "runStack": "Stack starten"
    },
    "tooltips": {
      "autoStack": "AutoStack",
      "results": "Ergebnisse"
    },
    "dialog": {
      "title": "AutoStack"
    },
    "alerts": {
      "lockReminder": "Denke daran, Flugzeuge zu sperren, die nicht bewegt werden sollen."
    }
  },
  "selectStackStrategy": {
    "common": {
      "notAvailable": "–",
      "noOverlap": "Kein Überlapp"
    },
    "strategies": {
      "normal": {
        "title": "Normal",
        "description": "Täglicher Betrieb mit SOPs."
      },
      "tight": {
        "title": "Eng",
        "description": "Optimiert für maximale Auslastung."
      },
      "loose": {
        "title": "Lose",
        "description": "Optimiert für einfaches Schleppen, auf Kosten der Auslastung."
      },
      "custom": {
        "title": "Eigene",
        "description": "Passe deine Stack-Einstellungen komplett an."
      }
    },
    "spacing": {
      "horizontal": "Horizontal: {{value}}",
      "overlapMin": "Überlappung Min: {{value}}"
    }
  },
  "selectTowingEquipment": {
    "labels": {
      "towingEquipment": "Schleppausrüstung für Stack",
      "ignore": "Ignorieren?"
    }
  },
  "stackResult": {
    "utilization": "Auslastung",
    "inside": "Innen",
    "outside": "Außen",
    "selectStack": "Stapel auswählen",
    "flagPoorLayout": "Schlechtes Layout melden"
  },
  "hangarPrintLayout": {
    "aircraft": "Flugzeug",
    "utilization": "Auslastung",
    "estValue": "Gesch. Wert",
    "estTowTime": "Schleppzeit",
    "footer": {
      "automaticallyOptimizedBy": "Automatisch optimiert von",
      "contactInfo": "Kontaktiere uns unter www.airplx.com oder peter@airplx.com."
    }
  }
}
